export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";

export const UPDATE_USER_REQUEST = "REGISTER_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const UPDATE_USER_FAIL = "REGISTER_USER_FAIL";

export const LOAD_USER_REQUEST = "LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL = "LOAD_USER_FAIL";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS"
export const LOGOUT_FAIL = "LOGOUT_FAIL"
 
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

export const VERIFICATION_CODE_REQUEST = "VERIFICATION_CODE_REQUEST";
export const VERIFICATION_CODE_SUCCESS = "VERIFICATION_CODE_SUCCESS";
export const VERIFICATION_CODE_FAIL = "VERIFICATION_CODE_FAIL";

export const VERIFY_CODE_REQUEST = "VERIFY_CODE_REQUEST";
export const VERIFY_CODE_SUCCESS = "VERIFY_CODE_SUCCESS";
export const VERIFY_CODE_FAIL = "VERIFY_CODE_FAIL";

export const USER_INTEREST_CREATE_REQUEST = "USER_INTEREST_CREATE_REQUEST"
export const USER_INTEREST_CREATE_SUCCESS = "USER_INTEREST_CREATE_SUCCESS"
export const USER_INTEREST_CREATE_FAIL = "USER_INTEREST_CREATE_FAIL"

export const GET_ALL_USER_INTEREST_REQUEST = "GET_ALL_USER_INTEREST_REQUEST"
export const GET_ALL_USER_INTEREST_SUCCESS = "GET_ALL_USER_INTEREST_SUCCESS"
export const GET_ALL_USER_INTEREST_FAIL = "GET_ALL_USER_INTEREST_FAIL"


export const CLEAR_ERRORS = "CLEAR_ERRORS";